import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";

import DashboardLayout from "../../UI/Layout/DashboardLayout";
import Spining from "../../UI/Spining/Spining";
import Title from "../../UI/Text/Title";
import WtPrev from "./WtPrev";
import WtPrev2 from "./WtPrev2";
import WtPrev3 from "./WtPrev3";
import WtPrev4 from "./WtPrev4";
import WtPrev5 from "./WtPrev5";
import WtPrev6 from "./WtPrev6";
import WtPrev7 from "./WtPrev7";
import WtPrev8 from "./WtPrev8";
import WtPrev9 from "./WtPrev9";
import "./WtPrev.css";
import "./WtPrev2.css";
import "./WtPrev3.css";
import "./WtPrev4.css";
import "./WtPrev5.css";
import "./WtPrev6.css";
import "./WtPrev7.css";
import "./WtPrev8.css";
import "./WtPrev9.css";
import { HOST_URL, NODE_HOST_URL, NODE_HOST_URL_API3_v1 } from "../api/Api";
import styles from "./WhatsappWidget.module.css";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import DataTable from "react-data-table-component";
import { customTableStylesForSummery } from "../../Utils/customTableStyles";
import Axios from "axios";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import Dialog from "react-dialog";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import WhatsappLogo from "../assets/img/WhatsappLogo-Photoroom.png";
import { handleUserLog } from "../../Utils/Utils";
const WhatsappWidget = () => {
  const lStorage = JSON.parse(localStorage.getItem("login"));
  const userId = lStorage?.user?.userId;
  const userToken = lStorage?.token;
  const currentUrl = window.location.hostname;
  const logo = lStorage.user.logo;
  const location = useLocation();


  const [selectedTemplate, setSelectedTemplate] = useState('template1');
  const handleTemplateChange = (e) => {
    setSelectedTemplate(e.target.value);
  };

  const errorDivRef = useRef(null);

  const [isLoading, setIsLoading] = useState(false);
  const [alert, setAlert] = useState({
    successMessage: false,
    errorMessage: "",
    bgColor: "",
  });

  const [whatsappno, setWhatsappno] = useState("+918860136424");
  const [displayname, setDisplayname] = useState("Authkey");

  const [logoFile, setLogoFile] = useState(null);
  const [logoUrl, setLogoUrl] = useState(
    "https://wpgallery.s3.ap-south-1.amazonaws.com/gallery/202408/66ab6e282f789.png"
  );
  const [wtbgcolor, setWtbgcolor] = useState("#008069");
  const [welcomeText, setWelcomeText] = useState(
    "Hi there 👋, How can I help you?"
  );
  const [preFilledMsg, setPreFilledMsg] = useState("hi");
  const [preFilledTemplate2, setPreFilledTemplate2] = useState("");
  const [preFilledTemplate3, setPreFilledTemplate3] = useState("");
  const [preFilledTemplate4, setPreFilledTemplate4] = useState("");
  const [preFilledTemplate5, setPreFilledTemplate5] = useState("");
  const [preFilledTemplate6, setPreFilledTemplate6] = useState("");
  const [preFilledTemplate7, setPreFilledTemplate7] = useState("");
  const [preFilledTemplate8, setPreFilledTemplate8] = useState("");
  const [preFilledTemplate9, setPreFilledTemplate9] = useState("");
  const [widgetStatus, setWidgetStatus] = useState("no");
  const [position, setPosition] = useState("right");
  const [sideMargin, setSideMargin] = useState("20");
  const [marginBottom, setMarginBottom] = useState("20");
  const [dialogOpen, setDialogOpen] = useState(false);
  const [responsedata, setResponseData] = useState();
  const [copystatus, setCopyStatus] = useState(false);
  const [disable, setDisable] = useState(false);
  const [widgetCreated, setWidgetCreated] = useState(false);
  const [widgetData, setWidgetData] = useState([]);
  const [noDataMessage, setNoDataMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [initialLoad, setInitialLoad] = useState(true);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [statusFilter, setStatusFilter] = useState("active");
  const [dateFilter, setDateFilter] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");


  const [isSignedUp, setIsSignedUp] = useState(false);
  const [showSignupPrompt, setShowSignupPrompt] = useState(false);


  useEffect(() => {
    if (currentUrl === "console.authkey.io") {
      setDisplayname("Authkey");
      setLogoUrl(
        "https://wpgallery.s3.ap-south-1.amazonaws.com/gallery/202408/66ab6e282f789.png"
      );
    } else {
      setDisplayname(currentUrl);
      setLogoUrl(WhatsappLogo);
    }
  }, []);

  useEffect(() => {
    fetchWhatsAppWidget(1);
  }, []);

  useEffect(() => {
    if (dateFilter === "custom" && fromDate && toDate) {
      fetchWhatsAppWidget(1, perPage || 10, statusFilter, dateFilter, fromDate, toDate);
      setCurrentPage(1);
    }
  }, [fromDate, toDate]);

  const handleStatusFilter = (filter) => {
    setStatusFilter(filter);
    setCurrentPage(1);
    fetchWhatsAppWidget(1, perPage || 10, filter, dateFilter, fromDate, toDate);
  };

  const handleDateFilterChange = (e) => {
    const val = e.target.value;
    setDateFilter(val);
    setCurrentPage(1);
    if (val !== "custom") {
      setFromDate("");
      setToDate("");
      fetchWhatsAppWidget(1, perPage || 10, statusFilter, val, "", "");
    }
  };

  const handleFromDateChange = (e) => {
    setFromDate(e.target.value);
    setCurrentPage(1);
  };

  const handleToDateChange = (e) => {
    setToDate(e.target.value);
    setCurrentPage(1);
  };

  const createWidget = () => {
    setWidgetCreated(true);
  };
  const handleLogoChange = (e) => {

    const file = e.target.files[0];

    const fileName = e.target.name;

    if (file) {

      setLogoFile(file);


      const img = new Image();  // Create an image object
      const reader = new FileReader();  // Create a FileReader to read the file

      // On file load, set the source of the image
      reader.onload = (e) => {
        img.src = e.target.result;  // Set the image source to the file data URL
      };
      reader.readAsDataURL(file);  // Read the file as data URL (base64 encoded)

      // When the image is loaded, you can display the preview
      img.onload = () => {

        setLogoUrl(img.src);  // Set the dashboard logo preview

      };
    }
  }

  const isActive = (status) => status === true || status === 1;

  const fetchWhatsAppWidget = async (page, limit, filter = statusFilter, df = dateFilter, fd = fromDate, td = toDate) => {
    setLoading(true);
    try {
      const body = {
        user_id: userId,
        token: userToken,
        method: "retrieve_wp_widget",
        page,
      };
      if (limit) body.limit = limit;
      if (filter) body.status_filter = filter;
      if (df) {
        body.date_filter = df;
        if (df === "custom" && fd && td) {
          body.from_date = fd;
          body.to_date = td;
        }
      }
      const res = await Axios.post(`${NODE_HOST_URL_API3_v1}/whatsapp_widget`, body);

      const rows = (res.data.data || []).map((widget) => ({
        id: widget.id,
        domains: widget.installed_domains?.map((d) => d.domain) || [],
        installed_at: widget.installed_domains?.[0]?.installed_at || "-",
        active: isActive(widget.status),
      }));

      setWidgetData(rows);
      setTotalRows(res.data.pagination?.total || 0);
      if (res.data.pagination?.limit) setPerPage(res.data.pagination.limit);
      if (!res.data.success) setNoDataMessage(res.data.message || "No data found.");
    } catch (error) {
      console.error("Error fetching widgets:", error);
    } finally {
      setLoading(false);
      setInitialLoad(false);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    fetchWhatsAppWidget(page, perPage, statusFilter, dateFilter, fromDate, toDate);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    setCurrentPage(page);
    fetchWhatsAppWidget(page, newPerPage, statusFilter, dateFilter, fromDate, toDate);
  };

  const columns = [
    {
      name: "ID",
      selector: (row) => row.id,
      width: "100px",
    },
    {
      name: "Domain",
      cell: (row) =>
        row.domains.length > 0 ? (
          <div className={styles.domainCell}>
            {row.domains.map((domain, i) => (
              <span key={i}>
                <a href={domain.startsWith("http") ? domain : `https://${domain}`} target="_blank" rel="noopener noreferrer">
                  {domain}
                </a>
                {i < row.domains.length - 1 && ", "}
              </span>
            ))}
          </div>
        ) : "-",
    },
    {
      name: "Installed At",
      selector: (row) => row.installed_at,
    },
    {
      name: "Status",
      width: "130px",
      cell: (row) =>
        row.active ? (
          <span className={styles.statusActive}>Active</span>
        ) : (
          <span className={styles.statusInactive}>Inactive</span>
        ),
    },
  ];

  


  const handleForm = async (e) => {
    e.preventDefault();


    if (whatsappno === "" || displayname === "" || welcomeText === "") {
      setAlert({
        successMessage: true,
        errorMessage: "Please fill all required input",
        bgColor: "alert alert-danger alert-dismissible",
      });
      return;
    }
    let logourl = ""
    if (logoFile) {
      const logodata = new FormData();
      logodata.append("amdfile", logoFile);
      logodata.append("doc_name", "image");
      logodata.append("doc_type", logoFile.type);
      logodata.append("user_id", userId);
      logodata.append("token", userToken);
      logodata.append("method", "create");
      const logores = await Axios.post(
        `${HOST_URL}/uploadFileWhatsapp.php`,
        logodata
      );

      if (logores.data.success === true) {
        logourl = logores.data.url;
      } else {

        setAlert({
          successMessage: true,
          errorMessage: logores.data.message,
          bgColor: "alert alert-success alert-dismissible",
        });
      }
    }

    let data = {
      user_id: userId,
      method: "create_wig",
      mobile_no: whatsappno,
      welcome_text: welcomeText,
      image_url: logourl,
      wig_position: position,
      back_color: wtbgcolor,
      bottom_align: marginBottom,
      side_align: sideMargin,
      default_open: widgetStatus === "yes" ? 1 : 0,
      display_name: displayname,
      pre_filled_message: preFilledMsg,
      pre_filled_Template2: preFilledTemplate2,
      temp_type: selectedTemplate
    };

    setIsLoading(true);
    try {
      const res = await Axios.post(`${NODE_HOST_URL_API3_v1}/whatsapp_widget`, data);
      setDisable(true)
      if (res.data.success === true) {
        setAlert({
          successMessage: true,
          errorMessage: res.data.message,
          bgColor: "alert alert-success alert-dismissible",
        });
        const scriptdata = `<script src="https://${currentUrl}/js/main.js" id="authkey-chat-widget" widget-id="${res.data.data}"></script>`;
        setResponseData(scriptdata);
        setDialogOpen(true);
        setDisable(false)
      } else {
        setAlert({
          successMessage: true,
          errorMessage: res.data.message,
          bgColor: "alert alert-danger alert-dismissible",
        });
        setDisable(false)
      }
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (alert.errorMessage && errorDivRef.current) {
      // Add a tiny delay to ensure DOM is updated
      setTimeout(() => {
        errorDivRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 100);
    }
  }, [alert.errorMessage]);



  const handleCloseDialog = () => {
    setDialogOpen(false);
  };
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(responsedata);
      setCopyStatus(true);
      setTimeout(() => setCopyStatus(false), 2000);
    } catch (err) {
      console.error("Failed to copy text:", err);
    }
  };


  return (
    <div>
      <DashboardLayout>
        {isLoading && <Spining />}
        <main className="content">
          <div className="container-fluid p-0">
            <div className="row mb-2 mb-xl-3">
              <div className="col-auto d-none d-sm-block">
                {/* <Title isButton={false}> WhatsApp Widget </Title> */}
                <nav className="text-center" aria-label="breadcrumb">
                  <ol className="breadcrumb bg-transparent p-0 mt-1 mb-0">
                    <li onClick={() => handleUserLog("" ," clicked_whatsapp_widget_tab", "whatsapp_widget", "user click on whatsapp widget tab", "whatsapp_widget")} className={`breadcrumb-item ${location.pathname === "/dashboard/whatsapp-widget" ? "active" : ""}`}>
                      <Link to="/dashboard/whatsapp-widget">WhatsApp Widget</Link>
                    </li>
                    <li onClick={() => handleUserLog("" , " clicked_whatsapp_widget_tab", "whatsapp_widget", "user click on widget QR tab", "whatsapp_widget")} className={`breadcrumb-item ${location.pathname === "/dashboard/whatsapp-widget-qr-code" ? "active" : ""}`}>
                      <Link to="/dashboard/whatsapp-widget-qr-code">Widget QR</Link>
                    </li>

                  </ol>
                </nav>
              </div>
              {(widgetData?.length > 0 &&
                <div className="col-auto ml-auto text-right mt-n1">
                  <Link to="/dashboard/whatsapp-widget-steps/:id?">
                    <span onClick={() => handleUserLog(""," clicked_create_whatsapp_widget_button", "whatsapp_widget", " Clicked on whatsapp widget button", "whatsapp_widget", "" , "")} className="btn btn-primary btn-sm">
                      Create Widget
                    </span>
                  </Link>
                </div>
              )}
            </div>

            {selectedTemplate === "template1" && <WtPrev
              temp_type={selectedTemplate}
              mobile_no={whatsappno}
              displayname={displayname}
              logourl={logoUrl}
              bgcolor={wtbgcolor}
              wltxt={welcomeText}
              wtstatus={widgetStatus}
              position={position}
              sidemargin={sideMargin}
              marginbottom={marginBottom}
              prefilledmsg={preFilledMsg}
            />}

            {selectedTemplate === "template2" && <WtPrev2
              temp_type={selectedTemplate}
              mobile_no={whatsappno}
              displayname={displayname}
              logourl={logoUrl}
              bgcolor={wtbgcolor}
              wltxt={welcomeText}
              wtstatus={widgetStatus}
              position={position}
              sidemargin={sideMargin}
              marginbottom={marginBottom}
              prefilledTemplate2={setPreFilledTemplate2}
            />}

            {selectedTemplate === "template3" && (
              <WtPrev3
                temp_type={selectedTemplate}
                mobile_no={whatsappno}
                displayname={displayname}
                logourl={logoUrl}
                bgcolor={wtbgcolor}
                wltxt={welcomeText}
                wtstatus={widgetStatus}
                position={position}
                sidemargin={sideMargin}
                marginbottom={marginBottom}
                prefilledmsg={preFilledMsg}
              />
            )}

            {selectedTemplate === "template4" && (
              <WtPrev4
                temp_type={selectedTemplate}
                mobile_no={whatsappno}
                displayname={displayname}
                logourl={logoUrl}
                bgcolor={wtbgcolor}
                wltxt={welcomeText}
                wtstatus={widgetStatus}
                position={position}
                sidemargin={sideMargin}
                marginbottom={marginBottom}
                prefilledmsg={preFilledMsg}
              />
            )}

            {selectedTemplate === "template5" && (
              <WtPrev5
                temp_type={selectedTemplate}
                mobile_no={whatsappno}
                displayname={displayname}
                logourl={logoUrl}
                bgcolor={wtbgcolor}
                wltxt={welcomeText}
                wtstatus={widgetStatus}
                position={position}
                sidemargin={sideMargin}
                marginbottom={marginBottom}
                prefilledmsg={preFilledMsg}
              />
            )}

            {selectedTemplate === "template6" && (
              <WtPrev6
                temp_type={selectedTemplate}
                mobile_no={whatsappno}
                displayname={displayname}
                logourl={logoUrl}
                bgcolor={wtbgcolor}
                wltxt={welcomeText}
                wtstatus={widgetStatus}
                position={position}
                sidemargin={sideMargin}
                marginbottom={marginBottom}
                prefilledmsg={preFilledMsg}
              />
            )}

            {selectedTemplate === "template7" && (
              <WtPrev7
                temp_type={selectedTemplate}
                mobile_no={whatsappno}
                displayname={displayname}
                logourl={logoUrl}
                bgcolor={wtbgcolor}
                wltxt={welcomeText}
                wtstatus={widgetStatus}
                position={position}
                sidemargin={sideMargin}
                marginbottom={marginBottom}
                prefilledmsg={preFilledMsg}
              />
            )}

            {selectedTemplate === "template8" && (
              <WtPrev8
                temp_type={selectedTemplate}
                mobile_no={whatsappno}
                displayname={displayname}
                logourl={logoUrl}
                bgcolor={wtbgcolor}
                wltxt={welcomeText}
                wtstatus={widgetStatus}
                position={position}
                sidemargin={sideMargin}
                marginbottom={marginBottom}
                prefilledmsg={preFilledMsg}
              />
            )}

            {selectedTemplate === "template9" && (
              <WtPrev9
                temp_type={selectedTemplate}
                mobile_no={whatsappno}
                displayname={displayname}
                logourl={logoUrl}
                bgcolor={wtbgcolor}
                wltxt={welcomeText}
                wtstatus={widgetStatus}
                position={position}
                sidemargin={sideMargin}
                marginbottom={marginBottom}
                prefilledmsg={preFilledMsg}
              />
            )}



            {alert.successMessage ? (
              <div className={alert.bgColor} role="alert">
                <button
                  type="button"
                  className="close"
                  data-dismiss="alert"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
                <div className="">{alert.errorMessage}</div>
              </div>
            ) : null}
            <div>

            </div>



            {dialogOpen && (
              <Dialog
                modal={true}
                title="Response Status"
                isDraggable={true}
                onClose={handleCloseDialog}
                maxWidth={"md"}
              >
                <div>
                  <p>
                    Copy and paste this code into desired place of your website
                    (HTML editor, website template, theme, etc.).
                  </p>
                </div>
                <div>
                  <button
                    onClick={handleCopy}
                    className="btn btn-success float-right"
                  >
                    <FontAwesomeIcon icon={faCopy} />{" "}
                    {copystatus ? "Copied" : "copy"}
                  </button>
                </div>
                <div
                  className="w-75"
                  style={{
                    border: "1px solid black",
                    backgroundColor: "#D4EDDA",
                    color: "FFFFFF",
                  }}
                >
                  <p>{responsedata}</p>
                </div>
                {/* <JSONPretty id="json-pretty" data={responsedata}></JSONPretty> */}
              </Dialog>
            )}


            {(widgetData?.length > 0 || dateFilter || statusFilter !== "active") && !initialLoad ? (
              <div className="row mt-3">
                <div className="col-12 col-lg-12 col-xxl-12">
                  <div className={styles.dateFilterRow}>
                    <span className={styles.dateFilterLabel}>Date Filter:</span>
                    <select
                      value={dateFilter}
                      onChange={handleDateFilterChange}
                      className={styles.dateFilterSelect}
                    >
                      <option value="">All Time</option>
                      <option value="today">Today</option>
                      <option value="yesterday">Yesterday</option>
                      <option value="last_7_days">Last 7 Days</option>
                      <option value="last_30_days">Last 30 Days</option>
                      <option value="this_month">This Month</option>
                      <option value="last_month">Last Month</option>
                      <option value="custom">Custom Range</option>
                    </select>
                    {dateFilter === "custom" && (
                      <>
                        <input
                          type="date"
                          value={fromDate}
                          onChange={handleFromDateChange}
                          className={styles.dateInput}
                          max={toDate || undefined}
                        />
                        <span className={styles.dateRangeSep}>to</span>
                        <input
                          type="date"
                          value={toDate}
                          onChange={handleToDateChange}
                          className={styles.dateInput}
                          min={fromDate || undefined}
                        />
                      </>
                    )}
                  </div>
                  <div className="card flex-fill table-content-show">
                    <div className={styles.filterBarHeader}>
                      <span className={styles.filterBarTitle}>Widget List</span>
                      <div className={styles.filterPillsWrap}>
                        {["active", "inactive"].map((f) => {
                          const isSelected = statusFilter === f;
                          const pillClass = isSelected
                            ? (f === "active" ? styles.filterPillGreenActive : styles.filterPillRedActive)
                            : "";
                          const dotClass = isSelected
                            ? (f === "active" ? styles.filterDotGreen : styles.filterDotRed)
                            : styles.filterDotGrey;
                          return (
                            <button
                              key={f}
                              onClick={() => handleStatusFilter(isSelected ? "" : f)}
                              className={`${styles.filterPill} ${pillClass}`}
                            >
                              <span className={`${styles.filterDot} ${dotClass}`} />
                              {f.charAt(0).toUpperCase() + f.slice(1)}
                            </button>
                          );
                        })}
                      </div>
                    </div>
                    <div className="table-responsive">
                      {initialLoad ? (
                        <Spining />
                      ) : (
                      <DataTable
                        columns={columns}
                        data={widgetData}
                        pagination
                        paginationServer
                        paginationTotalRows={totalRows}
                        paginationPerPage={perPage}
                        paginationComponentOptions={{ noRowsPerPage: true }}
                        onChangePage={handlePageChange}
                        progressPending={loading}
                        progressComponent={<Spining />}
                        highlightOnHover
                        customStyles={customTableStylesForSummery}
                        noHeader
                        noDataComponent={
                          <div className="p-4 text-center text-muted">
                            {noDataMessage || "No widgets found."}
                          </div>
                        }
                      />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ) : !initialLoad ? (
              <div className="d-flex justify-content-center align-items-center">
                <div className="d-flex justify-content-between alert alert-info text-center w-100  border-0 shadow-sm" role="alert" style={{ borderRadius: '0.5rem' }}>
                  <div className="popup-overlay">
                    <div className="popup-container container">
                      <div className="col-md-12 row">
                        {/* Left Column */}
                        <div className="col-12 col-md-6 d-flex flex-column justify-content-center align-items-start">
                          <h2 className="mb-2">Start Creating Widgets!</h2>
                          <p className="text-muted" style={{
                            margin: 0,
                            textAlign: 'left', // Ensures text starts from the left
                            fontSize: '1rem',
                          }}>No widgets have been created yet. Please create a widget to get started.</p>

                          <Link to={`/dashboard/whatsapp-widget-steps/:id`} className="btn btn-primary mt-2"
                           onClick={(
                            handleUserLog(
                              "",
                              "whatsapp_widget_created",
                              "whatsapp_widget",
                              "Whatsapp widget created successfully",
                              "whatsapp_widget",
                              "",
                              {}
                            )
                           )}>
                            Create Now
                          </Link>

                        </div>

                        {/* Right Column */}
                        <div className="col-12 col-md-6 p-0">
                          <img
                            src="https://authkey.io/img/whatsapp/whatsapp-widget.png"
                            alt="WhatsApp Widget Illustration"
                            className="img-fluid w-100 h-100 object-fit-cover"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            ) : null}
            {/* {!widgetCreated ? (
            
            <div className="table-responsive">
              <table className="table table-striped table-xs table-sm my-0">
                <thead>
                  <tr>
                    <th> ID</th>
                    <th> Widget Name</th>
                    <th> Mobile Number </th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {widgetData.length === 0 ? (
                    <tr>
                      <td colSpan="4">No Data Available</td> 
                    </tr>
                  ) : (
                    widgetData.map((item, i) => (
                      <tr key={i}>
                        <td>{item.id}</td>
                        <td>{item.wig_name}</td>
                        <td>{item.mobile_no}</td>
                        <td>
                          {item.status === 0 ? (
                            <span className="badge bg-warning mr-2">Pending</span>
                          ) : (
                            <span className="badge bg-primary mr-2">Created</span>
                          )}
                        </td>
                        <td><span className="badge bg-success mr-2">

                          Edit / Update
                        </span></td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
            ) : (
              <div className="d-flex justify-content-center align-items-center">
              <div className="d-flex justify-content-between alert alert-info text-center w-100  border-0 shadow-sm" role="alert" style={{ borderRadius: '0.5rem' }}>
                <p className="text-muted">No widgets have been created yet. Please create a widget to get started.</p>
                <button
                  type="button"
                  className="close  float-end"
                  data-dismiss="alert"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
            </div>
            
             )} */}




            {/* <div className="card "
              style={{
                border: "2px dashed #25D366",
                borderRadius: "20px",
                backgroundColor: "#e6f9f0",
                padding: "0rem",
                marginBottom: "0rem",
              }} >
              <div className="card-body">

                <form className="text-dark"> */}
            {/* <div className="form-row align-items-center">
                  <div className="form-group  col-12 col-sm-3">
                    <label htmlFor="formGroupExampleInput">
                      WhatsApp No.<span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="formGroupExampleInput"
                      placeholder="Enter WhatsApp No."
                      value={whatsappno}
                      onChange={(e) => setWhatsappno(e.target.value)}
                      required
                    />
                  </div>
                  <div className="form-group col-12 col-sm-3 ml-4">
                    <label htmlFor="formGroupExampleInput">
                      Display Name<span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="formGroupExampleInput"
                      placeholder="Enter Display Name"
                      value={displayname}
                      onChange={(e) => setDisplayname(e.target.value)}
                      required
                    />
                  </div>

                  <div className="form-group col-12 col-sm-3 ml-4">
                    <label htmlFor="formGroupExampleInput">Logo Upload</label>
                    <input
                      type="file"
                      className="form-control"
                      id="formGroupExampleInput"
                      placeholder="Enter logo url"
                      // value={logoUrl}
                      onChange={(e) => setLogoUrl(e.target.value)}
                    /> 
                    <small>
                      Note: Dimensions 1:1 and file should not exceed 50KB.
                    </small>
                  </div>

                  <div className="form-group  col-12 col-sm-2 ml-4">
                    <label htmlFor="formGroupExampleInput">
                      Background color
                    </label>
                    <input
                      type="color"
                      className="form-control"
                      id="formGroupExampleInput"
                      placeholder="Enter logo url"
                      value={wtbgcolor}
                      onChange={(e) => setWtbgcolor(e.target.value)}
                    />
                  </div>
                </div> */}
            {/* <div className="row">
                    <div className="col-sm-3">
                      <label htmlFor="formGroupExampleInput">
                        WhatsApp No.<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="formGroupExampleInput"
                        placeholder="Enter WhatsApp No."
                        value={whatsappno}
                        onChange={(e) => setWhatsappno(e.target.value)}
                        required
                      />
                    </div>
                    <div className="col-sm-3">
                      <label htmlFor="formGroupExampleInput">
                        Display Name<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="formGroupExampleInput"
                        placeholder="Enter Display Name"
                        value={displayname}
                        onChange={(e) => setDisplayname(e.target.value)}
                        required
                      />
                    </div>
                    <div className="col-sm-3">
                      <label htmlFor="formGroupExampleInput">Logo Upload</label>
                      <input
                        type="file"
                        className="form-control"
                        id="formGroupExampleInput"
                        placeholder="Enter logo url"
                        required

                      // value={logoUrl}
                      onChange={handleLogoChange}
                    />
                    <small className="text-danger" style={{ fontSize: "10px" }}>
                      Note: 1:1 ratio, file size ≤ 50KB.
                    </small>
                  </div>
                  <div className="col-sm-2">
                    <label htmlFor="formGroupExampleInput">
                      Background color
                    </label>
                    <input
                      type="color"
                      className="form-control"
                      id="formGroupExampleInput"
                      placeholder="Enter logo url"
                      value={wtbgcolor}
                      onChange={(e) => setWtbgcolor(e.target.value)}
                    />
                  </div>

                </div>

                <div className="form-row">

                  <div className="col-sm-4">
                    <label htmlFor="formGroupExampleInput">
                      Select Template
                    </label>
                    <div className="input-group drop-down-icons mb-2">
                      <select
                        className="form-control "
                        onChange={handleTemplateChange}
                        value={selectedTemplate}
                        required
                      >

                        <option value="template1" >Template 1 </option>
                        <option value="template2">Template 2</option>
                      </select>

                    </div>

                  </div>
                  <div className="ml-4">
                    <label>Open widget by default?</label>
                    <div>
                      <input
                        type="radio"
                        id="no"
                        name="wtopen"
                        value="no"
                        className="cursor-pointer form-check-input ml-1"
                        checked={widgetStatus === "no"}
                        onChange={(e) => setWidgetStatus(e.target.value)}
                      />
                      {" "}
                      <label htmlFor="no" className="cursor-pointer ml-4">
                        No
                      </label>
                      {" "}
                      <input
                        type="radio"
                        name="wtopen"
                        id="yes"
                        value="yes"
                        className="ml-4 cursor-pointer form-check-input"
                        checked={widgetStatus === "yes"}
                        onChange={(e) => setWidgetStatus(e.target.value)}
                      />
                      {" "}
                      <label htmlFor="yes" className="cursor-pointer ml-5">
                        Yes
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group col-md-4">
                    <label htmlFor="exampleFormControlTextarea1">
                      Welcome text<span style={{ color: "red" }}>*</span>
                    </label>
                    <textarea
                      className="form-control"
                      id="exampleFormControlTextarea1"
                      rows="3"
                      placeholder="Enter welcome text"
                      value={welcomeText}
                      onChange={(e) => setWelcomeText(e.target.value)}
                      maxLength={94}
                    ></textarea>
                  </div>

                  {selectedTemplate === "Template 1" && <div className="form-group col-md-4">
                    <label htmlFor="exampleFormControlTextarea1">
                      pre-filled message
                    </label>
                    <textarea
                      className="form-control"
                      id="exampleFormControlTextarea1"
                      rows="3"
                      placeholder="Enter pre-filled message"
                      value={preFilledMsg}
                      onChange={(e) => setPreFilledMsg(e.target.value)}
                      maxLength={94}
                    ></textarea>
                  </div>}


                  </div>
                  <div className="form-row mt-2 justify-content-between">
                    <div>
                      <label>Position</label>
                      <div>
                        <input
                          type="radio"
                          id="left"
                          name="position"
                          value="left"
                          className="cursor-pointer form-check-input ml-1"
                          checked={position === "left"}
                          onChange={(e) => setPosition(e.target.value)}
                        />
                        {" "}
                        <label htmlFor="left" className="cursor-pointer ml-4">
                          Left
                        </label>
                        {" "}
                        <input
                          type="radio"
                          name="position"
                          id="right"
                          value="right"
                          className="ml-4 cursor-pointer form-check-input"
                          checked={position === "right"}
                          onChange={(e) => setPosition(e.target.value)}
                        />
                        {" "}
                        <label htmlFor="right" className="cursor-pointer ml-5">
                          Right
                        </label>
                      </div>
                    </div>
                    <div>
                      <label htmlFor="margin-bottom">
                        Margin Bottom:{" "}
                        <span style={{ color: "#3B7DDD" }}>{marginBottom}px</span>
                      </label>
                      <input
                        type="range"
                        className="form-range"
                        min="0"
                        max="300"
                        id="margin-bottom"
                        value={marginBottom}
                        onChange={(e) => setMarginBottom(e.target.value)}
                      />
                    </div>
                    <div>
                      <label htmlFor="margin-right">
                        Margin Right:{" "}
                        <span style={{ color: "#3B7DDD" }}>{sideMargin}px</span>
                      </label>
                      <input
                        type="range"
                        className="form-range"
                        min="0"
                        max="300"
                        id="margin-right"
                        value={sideMargin}
                        onChange={(e) => setSideMargin(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="d-flex justify-content-center mt-2 ">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      onClick={handleForm}
                      disabled={disable ? true : false}
                    >
                      Create Widget
                    </button>
                  </div>
                </form>
              </div>
            </div> */}
            <div></div>
          </div>
        </main>
      </DashboardLayout>
    </div>
  );
};

export default WhatsappWidget;
